import { useCallback, useContext } from 'react';
import { StepContext } from '../providers/StepProvider';
import { StepActionType } from '../types/stepsTypes';

/**
 * Provee el estado y el manejo de estado de los pasos del proceso de creación de oferta
 */
export const useStepState = () => {
  const { state, dispatch } = useContext(StepContext);

  const nextStep = useCallback(() => {
    dispatch({
      type: StepActionType.NEXT_STEP,
    });
  }, [dispatch]);

  const prevStep = useCallback(() => {
    dispatch({
      type: StepActionType.PREV_STEP,
    });
  }, [dispatch]);

  const setCurrentStep = useCallback(
    (currentStep: number) => {
      dispatch({
        type: StepActionType.SET_STEP,
        payload: currentStep,
      });
    },
    [dispatch],
  );

  return {
    ...state,
    nextStep,
    prevStep,
    setCurrentStep,
  };
};
